import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
/* eslint-disable react/jsx-one-expression-per-line */

/* eslint-disable jsx-a11y/label-has-for */

/* eslint-disable jsx-a11y/label-has-associated-control */


import React from 'react';
import { CardElement, injectStripe } from 'react-stripe-elements';
import { Button, Checkbox, Divider, Grid, Input, Modal, Popup } from 'semantic-ui-react';
import axios from 'axios';
import LogRocket from 'logrocket';
import _debounce from 'lodash/debounce';
import _get from 'lodash/get';
import subscriptionPlans from '../data/subscription-plans';
import { paymentTypes, CUSTOM_PLAN_INDEX } from '../data/payment-types';
import { BusinessPropType } from '../../../services/proptypes';
var TOS = 'https://gofisherman.com/terms-of-service/';

var CheckoutForm = /*#__PURE__*/function (_React$Component) {
  _inherits(CheckoutForm, _React$Component);

  var _super = _createSuper(CheckoutForm);

  function CheckoutForm(props) {
    var _this;

    _classCallCheck(this, CheckoutForm);

    _this = _super.call(this, props);
    _this.state = {
      couponCode: null,
      couponCodeValid: true,
      cancelToken: undefined,
      firstName: null,
      lastName: null,
      address: null,
      city: null,
      state: null,
      zipCode: null,
      email: props.email || null,
      phoneNumber: null,
      termsAccepted: false,
      submitEnabled: false,
      checkoutLoading: false,
      showErrorMessage: false,
      error: null
    };
    _this.onSubmit = _this.onSubmit.bind(_assertThisInitialized(_this));
    _this.onCouponChanged = _this.onCouponChanged.bind(_assertThisInitialized(_this));
    _this.onFirstNameChanged = _this.onFirstNameChanged.bind(_assertThisInitialized(_this));
    _this.onLastNameChanged = _this.onLastNameChanged.bind(_assertThisInitialized(_this));
    _this.onAddressChanged = _this.onAddressChanged.bind(_assertThisInitialized(_this));
    _this.onCityChanged = _this.onCityChanged.bind(_assertThisInitialized(_this));
    _this.onStateChanged = _this.onStateChanged.bind(_assertThisInitialized(_this));
    _this.onZipCodeChanged = _this.onZipCodeChanged.bind(_assertThisInitialized(_this));
    _this.onEmailChanged = _this.onEmailChanged.bind(_assertThisInitialized(_this));
    _this.onPhoneNumberChanged = _this.onPhoneNumberChanged.bind(_assertThisInitialized(_this));
    _this.onLoadCompleted = _this.onLoadCompleted.bind(_assertThisInitialized(_this));
    _this.checkInputs = _this.checkInputs.bind(_assertThisInitialized(_this));
    _this.onCheckoutError = _this.onCheckoutError.bind(_assertThisInitialized(_this));
    _this.checkCouponDebounced = _debounce(_this.checkCoupon, 1000);
    _this.toggleTerms = _this.toggleTerms.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CheckoutForm, [{
    key: "onCouponChanged",
    value: function onCouponChanged(e, _ref) {
      var _this2 = this;

      var value = _ref.value;
      this.setState({
        couponCode: value.trim()
      }, function () {
        _this2.checkCouponDebounced();
      });
    }
  }, {
    key: "onFirstNameChanged",
    value: function onFirstNameChanged(e, _ref2) {
      var _this3 = this;

      var value = _ref2.value;
      this.setState({
        firstName: value
      }, function () {
        _this3.checkInputs();
      });
    }
  }, {
    key: "onLastNameChanged",
    value: function onLastNameChanged(e, _ref3) {
      var _this4 = this;

      var value = _ref3.value;
      this.setState({
        lastName: value
      }, function () {
        _this4.checkInputs();
      });
    }
  }, {
    key: "onAddressChanged",
    value: function onAddressChanged(e, _ref4) {
      var _this5 = this;

      var value = _ref4.value;
      this.setState({
        address: value
      }, function () {
        _this5.checkInputs();
      });
    }
  }, {
    key: "onCityChanged",
    value: function onCityChanged(e, _ref5) {
      var _this6 = this;

      var value = _ref5.value;
      this.setState({
        city: value
      }, function () {
        _this6.checkInputs();
      });
    }
  }, {
    key: "onStateChanged",
    value: function onStateChanged(e, _ref6) {
      var _this7 = this;

      var value = _ref6.value;
      this.setState({
        state: value
      }, function () {
        _this7.checkInputs();
      });
    }
  }, {
    key: "onZipCodeChanged",
    value: function onZipCodeChanged(e, _ref7) {
      var _this8 = this;

      var value = _ref7.value;
      var onlyAlphanumeric = value.replaceAll(/[^a-zA-Z0-9]/g, '');
      this.setState({
        zipCode: onlyAlphanumeric
      }, function () {
        _this8.checkInputs();
      });
    }
  }, {
    key: "onEmailChanged",
    value: function onEmailChanged(e, _ref8) {
      var _this9 = this;

      var value = _ref8.value;
      this.setState({
        email: value
      }, function () {
        _this9.checkInputs();
      });
    }
  }, {
    key: "onPhoneNumberChanged",
    value: function onPhoneNumberChanged(e, _ref9) {
      var _this10 = this;

      var value = _ref9.value;
      var onlyNumbers = value.replaceAll(/[^0-9]/g, '');
      this.setState({
        phoneNumber: onlyNumbers
      }, function () {
        _this10.checkInputs();
      });
    }
  }, {
    key: "onLoadCompleted",
    value: function onLoadCompleted() {
      this.setState({
        checkoutLoading: false
      });
    }
  }, {
    key: "onCheckoutError",
    value: function onCheckoutError(error) {
      this.setState({
        showErrorMessage: true,
        error: error
      });
      this.onLoadCompleted();
    }
  }, {
    key: "onSubmit",
    value: function () {
      var _onSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this11 = this;

        var _this$props, business, currentPlanIndex, isAnnual, stripe, onCheckoutCompleted, currentDomain, customDomain, _this$state, firstName, lastName, address, city, state, zipCode, email, phoneNumber, couponCode, couponCodeValid, planIndex, stripeCardholderData, _yield$stripe$createT, token, error, url, headers, domainType, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  checkoutLoading: true,
                  error: null
                });
                _this$props = this.props, business = _this$props.business, currentPlanIndex = _this$props.currentPlanIndex, isAnnual = _this$props.isAnnual, stripe = _this$props.stripe, onCheckoutCompleted = _this$props.onCheckoutCompleted, currentDomain = _this$props.currentDomain, customDomain = _this$props.customDomain;
                _this$state = this.state, firstName = _this$state.firstName, lastName = _this$state.lastName, address = _this$state.address, city = _this$state.city, state = _this$state.state, zipCode = _this$state.zipCode, email = _this$state.email, phoneNumber = _this$state.phoneNumber, couponCode = _this$state.couponCode, couponCodeValid = _this$state.couponCodeValid;
                planIndex = isAnnual ? currentPlanIndex * 2 : currentPlanIndex * 2 + 1;
                stripeCardholderData = {
                  name: "".concat(firstName, " ").concat(lastName),
                  address_line1: address,
                  address_city: city,
                  address_state: state,
                  address_zip: zipCode
                };
                _context.next = 7;
                return stripe.createToken(stripeCardholderData);

              case 7:
                _yield$stripe$createT = _context.sent;
                token = _yield$stripe$createT.token;
                error = _yield$stripe$createT.error;
                url = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL;
                headers = {
                  'x-api-key': process.env.X_API_KEY || process.env.STORYBOOK_X_API_KEY
                }; // Stripe createToken error handling

                if (!error) {
                  _context.next = 16;
                  break;
                }

                this.setState({
                  error: error.message
                });
                this.onCheckoutError();
                return _context.abrupt("return");

              case 16:
                domainType = customDomain === null ? 'internal' : 'external';
                data = {
                  stripe_token: token.id,
                  stripe_subscription_plan: subscriptionPlans[planIndex].id,
                  customer: {
                    firstName: firstName,
                    lastName: lastName,
                    address: address,
                    city: city,
                    state: state,
                    zipCode: zipCode,
                    email: email,
                    phoneNumber: phoneNumber
                  },
                  domain: domainType === 'internal' ? currentDomain.DomainName : customDomain,
                  domainType: domainType
                };

                if (couponCode && couponCode.length > 0 && couponCodeValid) {
                  data.coupon = couponCode;
                }

                axios.post("".concat(url, "businesses/").concat(business.type, "s/").concat(business.id, "/subscriptions/"), data, {
                  headers: headers
                }).then(function () {
                  _this11.onLoadCompleted();

                  onCheckoutCompleted();
                })["catch"](function (err) {
                  _this11.onLoadCompleted();

                  if (err) {
                    var errorMsg = null;

                    var responseStatus = _get(err, 'response.status');

                    if (responseStatus === 304) {
                      errorMsg = 'Customer already exists for this card, please contact support@gofisherman.com';
                    }

                    if (responseStatus === 400) {
                      errorMsg = _get(err, 'response.data.message');
                    }

                    _this11.onCheckoutError(errorMsg);
                  }
                });

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSubmit() {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }()
  }, {
    key: "toggleTerms",
    value: function toggleTerms() {
      var _this12 = this;

      this.setState(function (prevState) {
        return {
          termsAccepted: !prevState.termsAccepted
        };
      }, function () {
        return _this12.checkInputs();
      });
    }
  }, {
    key: "checkInputs",
    value: function checkInputs() {
      var _this$state2 = this.state,
          firstName = _this$state2.firstName,
          lastName = _this$state2.lastName,
          address = _this$state2.address,
          city = _this$state2.city,
          state = _this$state2.state,
          zipCode = _this$state2.zipCode,
          email = _this$state2.email,
          phoneNumber = _this$state2.phoneNumber,
          termsAccepted = _this$state2.termsAccepted;
      var submitEnabled = firstName && lastName && address && city && state && zipCode && email && phoneNumber && termsAccepted;
      this.setState({
        submitEnabled: submitEnabled
      });
    }
  }, {
    key: "checkCoupon",
    value: function checkCoupon() {
      var _this13 = this;

      var _this$state3 = this.state,
          couponCode = _this$state3.couponCode,
          cancelToken = _this$state3.cancelToken;
      var url = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL;
      var headers = {
        'x-api-key': process.env.X_API_KEY || process.env.STORYBOOK_X_API_KEY
      }; // Check if there are any previous pending requests

      if (cancelToken !== undefined) {
        cancelToken.cancel('Operation canceled due to new request.');
      } // Save the cancel token for the current request


      var newCancelToken = axios.CancelToken.source();
      this.setState({
        cancelToken: newCancelToken
      });
      var data = {
        code: couponCode
      };
      axios.post("".concat(url, "businesses/discounts/check/"), data, {
        headers: headers,
        cancelToken: newCancelToken.token
      }).then(function (res) {
        var responseData = res.data;

        _this13.setState({
          couponCodeValid: true,
          couponCodeDescription: responseData.description
        });
      })["catch"](function (err) {
        if (err.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          var responseData = err.response.data;
          var couponCodeError = 'Invalid Coupon';

          if (responseData && responseData.error) {
            couponCodeError = responseData.error;
          }

          _this13.setState({
            couponCodeValid: false,
            couponCodeDescription: undefined,
            couponCodeError: couponCodeError
          });
        } else {
          // The request was made but no response was received or something
          // else happened: err.request or err.message can have more info
          LogRocket.captureException(err);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          currentPlanIndex = _this$props2.currentPlanIndex,
          isAnnual = _this$props2.isAnnual,
          currentDomain = _this$props2.currentDomain;
      var _this$state4 = this.state,
          submitEnabled = _this$state4.submitEnabled,
          checkoutLoading = _this$state4.checkoutLoading,
          showErrorMessage = _this$state4.showErrorMessage,
          error = _this$state4.error,
          couponCode = _this$state4.couponCode,
          couponCodeValid = _this$state4.couponCodeValid,
          couponCodeDescription = _this$state4.couponCodeDescription,
          couponCodeError = _this$state4.couponCodeError,
          firstName = _this$state4.firstName,
          lastName = _this$state4.lastName,
          address = _this$state4.address,
          city = _this$state4.city,
          state = _this$state4.state,
          zipCode = _this$state4.zipCode,
          email = _this$state4.email,
          phoneNumber = _this$state4.phoneNumber,
          termsAccepted = _this$state4.termsAccepted;
      var paymentPlan = paymentTypes[currentPlanIndex];
      var totalIfNotAdvanced = isAnnual ? paymentPlan.monthly.price * 12 : paymentPlan.monthly.price;
      var baseTotal = currentPlanIndex < CUSTOM_PLAN_INDEX ? totalIfNotAdvanced : null;
      var discount = isAnnual ? paymentPlan.monthly.price * 2 : 0;
      var total = baseTotal - discount;
      var planIndex = isAnnual ? currentPlanIndex * 2 : currentPlanIndex * 2 + 1;
      var plan = subscriptionPlans[planIndex];
      var planDisplayName = plan.name.split(' - ')[0] + (isAnnual ? ' x 12 months' : ' x 1 month');
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal.Header, {
        className: "modal-header"
      }, "Checkout"), /*#__PURE__*/React.createElement(Grid, {
        stackable: true,
        className: "checkout checkout-body"
      }, /*#__PURE__*/React.createElement(Grid.Row, {
        className: "checkout-payment-heading-row"
      }, /*#__PURE__*/React.createElement(Grid.Column, {
        computer: 8,
        tablet: 8,
        mobile: 16,
        className: "checkout-border checkout-payment-details",
        id: "checkout-payment-details-firstcol"
      }, /*#__PURE__*/React.createElement("h3", {
        className: "header-text blue-color"
      }, "Payment Details"), /*#__PURE__*/React.createElement(Divider, {
        className: "checkout-divider"
      }), /*#__PURE__*/React.createElement("p", {
        className: "checkout-subheader body-text blue-color"
      }, "Billing Information"), /*#__PURE__*/React.createElement(CardElement, {
        className: "stripe-checkout-input"
      }), /*#__PURE__*/React.createElement(Input, {
        value: couponCode,
        id: "coupon-code-input",
        className: "checkout-input",
        placeholder: "Coupon Code",
        onChange: this.onCouponChanged
      }), couponCode && couponCode.length > 0 && !couponCodeValid && /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'red'
        }
      }, "Error:", couponCodeError), couponCode && couponCodeDescription && /*#__PURE__*/React.createElement("p", null, "Code unlocked: ", couponCodeDescription), /*#__PURE__*/React.createElement(Divider, {
        className: "checkout-divider"
      }), /*#__PURE__*/React.createElement("p", {
        className: "checkout-subheader body-text blue-color"
      }, "Billing Address"), /*#__PURE__*/React.createElement(Input, {
        value: firstName,
        id: "first-name-input",
        className: "checkout-input check-input-half check-input-half-first",
        placeholder: "First Name",
        onChange: this.onFirstNameChanged
      }), /*#__PURE__*/React.createElement(Input, {
        value: lastName,
        id: "last-name-input",
        className: "checkout-input check-input-half",
        placeholder: "Last Name",
        onChange: this.onLastNameChanged
      }), /*#__PURE__*/React.createElement(Input, {
        value: address,
        id: "address-input",
        className: "checkout-input",
        placeholder: "Address",
        onChange: this.onAddressChanged
      }), /*#__PURE__*/React.createElement(Input, {
        value: city,
        id: "city-input",
        className: "checkout-input check-input-half check-input-half-first",
        placeholder: "City",
        onChange: this.onCityChanged
      }), /*#__PURE__*/React.createElement(Input, {
        calue: state,
        id: "state-input",
        className: "checkout-input checkout-input-quarter checkout-input-quarter-first",
        placeholder: "State",
        onChange: this.onStateChanged
      }), /*#__PURE__*/React.createElement(Input, {
        value: zipCode,
        id: "zip-code-input",
        className: "checkout-input checkout-input-quarter",
        placeholder: "Zip Code",
        onChange: this.onZipCodeChanged,
        input: /*#__PURE__*/React.createElement("input", {
          maxLength: "6"
        })
      }), /*#__PURE__*/React.createElement(Input, {
        value: email,
        id: "email-input",
        className: "checkout-input check-input-half check-input-half-first",
        placeholder: "Email",
        onChange: this.onEmailChanged
      }), /*#__PURE__*/React.createElement(Input, {
        value: phoneNumber,
        id: "phone-number-input",
        className: "checkout-input check-input-half",
        placeholder: "Phone Number",
        onChange: this.onPhoneNumberChanged,
        input: /*#__PURE__*/React.createElement("input", {
          maxLength: "20"
        })
      })), /*#__PURE__*/React.createElement(Grid.Column, {
        computer: 1,
        tablet: 1,
        only: "computer tablet"
      }), /*#__PURE__*/React.createElement(Grid.Column, {
        computer: 7,
        tablet: 7,
        mobile: 16,
        className: "checkout-border checkout-payment-details"
      }, /*#__PURE__*/React.createElement("h3", {
        className: "header-text blue-color"
      }, "Order Summary"), /*#__PURE__*/React.createElement("p", null, "Once you place the order, we\u2019ll connect your website to your selected domain and notify you when the site is live. If you have an existing domain, someone from our team will contact you to connect it."), /*#__PURE__*/React.createElement(Divider, {
        className: "checkout-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "body-text blue-color checkout-row"
      }, /*#__PURE__*/React.createElement("p", {
        className: "checkout-row-right"
      }, "$", baseTotal), /*#__PURE__*/React.createElement("p", null, planDisplayName)), discount !== 0 && /*#__PURE__*/React.createElement("div", {
        className: "body-text blue-color checkout-row"
      }, /*#__PURE__*/React.createElement("p", {
        className: "checkout-row-right"
      }, "-$", discount), /*#__PURE__*/React.createElement("p", null, "Annual plan savings")), currentDomain.DomainName && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "body-text blue-color checkout-row"
      }, /*#__PURE__*/React.createElement("p", {
        className: "checkout-row-right strike-through-text"
      }, "$15"), /*#__PURE__*/React.createElement("p", null, "Domain Service")), /*#__PURE__*/React.createElement("div", {
        className: "checkout-row checkout-domain-description checkout-row"
      }, /*#__PURE__*/React.createElement("p", {
        className: "checkout-row-right green-color"
      }, "FREE"), /*#__PURE__*/React.createElement("p", null, currentDomain.DomainName || /*#__PURE__*/React.createElement("div", null, "\xA0")))), /*#__PURE__*/React.createElement("div", {
        className: "blue-color checkout-row"
      }, /*#__PURE__*/React.createElement("p", {
        className: "checkout-row-right bolded"
      }, "$", total), /*#__PURE__*/React.createElement("p", {
        className: "checkout-row-left bolded"
      }, "Total")), /*#__PURE__*/React.createElement("div", {
        className: "terms-of-use"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        label: /*#__PURE__*/React.createElement("label", {
          style: {
            fontSize: 16
          }
        }, "I agree to Fisherman\u2019s", ' ', /*#__PURE__*/React.createElement("a", {
          className: "tos-link",
          href: TOS,
          target: "_blank",
          rel: "noopener noreferrer"
        }, "Terms and Conditions")),
        onChange: this.toggleTerms,
        value: termsAccepted
      })), submitEnabled ? /*#__PURE__*/React.createElement(Button, {
        style: {
          border: '2px solid red !important',
          width: '100%'
        },
        className: "centered-button checkout-button-enabled",
        onClick: this.onSubmit,
        loading: checkoutLoading
      }, "Place Order") : /*#__PURE__*/React.createElement(Popup, {
        content: "You must accept the Terms of Use to complete the payment",
        trigger: /*#__PURE__*/React.createElement(Button, {
          className: "centered-button checkout-button-disabled"
        }, "Place Order")
      }), showErrorMessage && /*#__PURE__*/React.createElement("p", {
        className: "error-message centered-content"
      }, "There was an issue processing your payment", error && /*#__PURE__*/React.createElement(React.Fragment, null, ": ", error))))));
    }
  }]);

  return CheckoutForm;
}(React.Component);

CheckoutForm.defaultProps = {
  customDomain: null,
  email: null
};
export default injectStripe(CheckoutForm);